<template>
  <div class="form-field">
    <div class="form-label">
      {{label}}
    </div>
    <div :class="'form-input multiple' + (opened?' opened':'')" @click="clickOptionsHandler">
       <div v-for="option in modelValue" :key="option.id">
          <slot name="selectedOption" :option="option">
            <div class="selected-option" >
                <span class="selected-option-title">
                  {{option.title}}
                </span>
                <span class="selected-option-cross" :data-id="option.id">×</span>
            </div>
          </slot>
       </div>
    </div>
    <div class="form-options" v-show="opened">
      <ul>
        <li
            v-for="(option, index) in options"
            :key="index"
            @click="select(option.id)"
            :class="modelValue.includes(option)?'selected':''"
        >
          <span class="option-checkbox"></span>
          {{ option?.[title] }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits, ref } from 'vue'
  const opened = ref(false)
  const emit = defineEmits(['update:modelValue'])
  const props = defineProps({
    modelValue: {
      type: Array,
      required: true
    },
    label: String,
    placeholder: {
      type:String,
      default: 'Выберите из списка'
    },
    options: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default:'title'
    }
  })

  function clickOptionsHandler(event) {
    if(event.target.classList.contains('selected-option-cross')) {
      select(event.target.getAttribute('data-id'))
    }else if (event.target.classList.contains('form-input')){
      openClose()
    }
  }
  function select(optionId) {
    event.stopPropagation()
    const newOptions = props.modelValue
    const index = newOptions.findIndex((option) => option.id == optionId)
    if (index === -1){
      newOptions.push(props.options.find((option) => option.id == optionId))
    }else{
      newOptions.splice(index, 1)
    }
    emit('update:modelValue', newOptions)
  }
  function openClose() {
    if (opened.value === false) {
      opened.value = true;
        setTimeout(() => {
          document.body.addEventListener('click', openClose);
        }, 100);
    } else {
      document.body.removeEventListener('click', openClose);
      opened.value = false;
    }
  }
</script>
<style>
#import-calculator .selected-option{
  color:#333333;
  background: #D8E7FF;
  border-radius: 4px;
  padding-left: 5px;
  font-size: 14px;
  line-height: 19px;
}
#import-calculator .selected-option-title{
  padding-right: 5px;
  cursor: auto;
}
#import-calculator .selected-option-cross{
  font-size: 20px;
  position: relative;
  top: 3px;
  color: darkgray;
  padding: 0 5px;
}
#import-calculator .form-input.multiple {
  height: auto;
  padding: 7px 10px;
  cursor: pointer;
  display: flex;
  min-height: 36px;
  flex-wrap: wrap;
  gap:10px
}

#import-calculator .option-checkbox {
  display: inline-block;
  width: 13px;
  height: 13px;
  border: 1.4px solid #333;
  border-radius: 1px;
  position: relative;
  margin-right: 5px;
  top: 2px;
}
#import-calculator li.selected .option-checkbox {
  border: 1.4px solid #FA4B4C;
}
#import-calculator li.selected .option-checkbox:after {
  content: "";
  position: absolute;
  top: 40%;
  left: 55%;
  width: 2.5px;
  height: 6px;
  border: 1.5px solid #FA4B4C;
  border-top: none;
  border-left: none;
  transform: translate(-50%, -50%) rotate(45deg);
}
</style>